import { useCookies } from 'react-cookie'
import { GetCart } from '../../../../apps/checkout/src/client/graphql/queries'

const cartIdCookieName = '_sg_cartId'

const useQueryFallback = (): any => undefined

function useCart(useQuery = useQueryFallback as any): any {
  const [cookies] = useCookies([cartIdCookieName])

  const cartId = cookies[cartIdCookieName]

  const result = useQuery(GetCart, {
    context: { version: 2 },
    variables: { id: cartId },
    skip: !cartId,
  })

  return result?.data?.cart
}

export default useCart
